/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GarantieTarifDto } from './GarantieTarifDto';
import {
    GarantieTarifDtoFromJSON,
    GarantieTarifDtoFromJSONTyped,
    GarantieTarifDtoToJSON,
    GarantieTarifDtoToJSONTyped,
} from './GarantieTarifDto';

/**
 * Détail de tarification d'un bien du parc.
 * @export
 * @interface BienTarifDto
 */
export interface BienTarifDto {
    /**
     * 
     * @type {string}
     * @memberof BienTarifDto
     */
    bienImmobilierId?: string;
    /**
     * 
     * @type {number}
     * @memberof BienTarifDto
     */
    primePure?: number;
    /**
     * 
     * @type {number}
     * @memberof BienTarifDto
     */
    primePureTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof BienTarifDto
     */
    prixHT?: number;
    /**
     * 
     * @type {number}
     * @memberof BienTarifDto
     */
    taxe?: number;
    /**
     * 
     * @type {number}
     * @memberof BienTarifDto
     */
    prixTTC?: number;
    /**
     * 
     * @type {Array<GarantieTarifDto>}
     * @memberof BienTarifDto
     */
    garanties?: Array<GarantieTarifDto> | null;
}

/**
 * Check if a given object implements the BienTarifDto interface.
 */
export function instanceOfBienTarifDto(value: object): value is BienTarifDto {
    return true;
}

export function BienTarifDtoFromJSON(json: any): BienTarifDto {
    return BienTarifDtoFromJSONTyped(json, false);
}

export function BienTarifDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BienTarifDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bienImmobilierId': json['bienImmobilierId'] == null ? undefined : json['bienImmobilierId'],
        'primePure': json['primePure'] == null ? undefined : json['primePure'],
        'primePureTotal': json['primePureTotal'] == null ? undefined : json['primePureTotal'],
        'prixHT': json['prixHT'] == null ? undefined : json['prixHT'],
        'taxe': json['taxe'] == null ? undefined : json['taxe'],
        'prixTTC': json['prixTTC'] == null ? undefined : json['prixTTC'],
        'garanties': json['garanties'] == null ? undefined : ((json['garanties'] as Array<any>).map(GarantieTarifDtoFromJSON)),
    };
}

export function BienTarifDtoToJSON(json: any): BienTarifDto {
    return BienTarifDtoToJSONTyped(json, false);
}

export function BienTarifDtoToJSONTyped(value?: BienTarifDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bienImmobilierId': value['bienImmobilierId'],
        'primePure': value['primePure'],
        'primePureTotal': value['primePureTotal'],
        'prixHT': value['prixHT'],
        'taxe': value['taxe'],
        'prixTTC': value['prixTTC'],
        'garanties': value['garanties'] == null ? undefined : ((value['garanties'] as Array<any>).map(GarantieTarifDtoToJSON)),
    };
}

